import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getSid() {
  let s = localStorage.getItem("sav_sid");
  if (!s) {
    s = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    localStorage.setItem("sav_sid", s);
  }
  return s;
}

let pageStart = Date.now();
let lastPath = "";

export function trackPage(path) {
  lastPath = path;
  pageStart = Date.now();
  axios.post(`${API}/track`, { session_id: getSid(), path, referrer: document.referrer || "" }).catch(() => {});
}

// Lead / conversion events. Stored via the existing /api/track (no backend change): the
// event name is encoded in the path and metadata (service/source + UTM) in the referrer field.
export function trackEvent(name, meta = {}) {
  let utm = "";
  try { utm = new URLSearchParams(window.location.search).get("utm_source") || ""; } catch (e) {}
  const payload = { session_id: getSid(), path: `event:${name}`, referrer: JSON.stringify({ ...meta, utm, from: window.location.pathname }) };
  axios.post(`${API}/track`, payload).catch(() => {});
}

export function flushDuration() {
  const duration = Math.max(0, (Date.now() - pageStart) / 1000);
  const payload = JSON.stringify({ session_id: getSid(), path: lastPath, referrer: "", duration });
  try {
    if (navigator.sendBeacon) navigator.sendBeacon(`${API}/track`, new Blob([payload], { type: "application/json" }));
  } catch (e) {}
}
